import * as React from "react";
import { Breadcrumb, message, Row, Tooltip } from "antd";
import { observer } from "mobx-react";
import { ItemType } from "antd/lib/breadcrumb/Breadcrumb";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { I18N_NS } from "Config/i18n";
import { useTranslation } from "react-i18next";

export interface DocumentsBreadCrumbConfig {
  title?: string;
  folderId: number;
}

interface DocumentsBreadcrumbsProps {
  config: DocumentsBreadCrumbConfig[];
  goToFolder: (folderId: number) => void;
  enableCopyButton?: boolean;
}

export const DocumentsBreadcrumbs: React.FunctionComponent<DocumentsBreadcrumbsProps> = observer(
  ({ config = [], goToFolder, enableCopyButton }: DocumentsBreadcrumbsProps) => {
    const { t } = useTranslation(I18N_NS.PROJECT);
    const lastIndex = config.length - 1;
    const breadCrumbs: ItemType[] = config.map((item, idx) => {
      if (idx === lastIndex) {
        return {
          key: item.folderId,
          className: "active-crumb",
          title: item.title,
        };
      }
      return {
        key: item.folderId,
        title: (
          <span className="breadcrumb-item" onClick={() => goToFolder(item.folderId)}>
            {item.title}
          </span>
        ),
      };
    });

    const handleCopyFolderPath = async () => {
      try {
        const url = window.location.href;
        const domain = new URL(url).hostname;
        const folderPath = config.map((folder) => folder.title).join("/");
        await navigator.clipboard.write([
          new ClipboardItem({
            "text/plain": new Blob([url], { type: "text/plain" }),
            "text/html": new Blob([`<a href="${url}">${`PAVE | ${domain} | ` + folderPath}</a>`], {
              type: "text/html",
            }),
          }),
        ]);
        message.success(t("Copied"));
      } catch (err) {
        console.error("Failed to copy: ", err);
        const url = window.location.href;
        navigator.clipboard.writeText(url);
      }
    };

    return (
      <Row style={{ margin: "10px 0" }}>
        <Breadcrumb separator=">" items={breadCrumbs} />
        {enableCopyButton && config.length ? (
          <Tooltip title={t("Copy folder path")}>
            <FontAwesomeIcon
              icon={["far", "copy"]}
              size={"lg"}
              style={{ marginLeft: 10, cursor: "pointer" }}
              onClick={handleCopyFolderPath}
            />
          </Tooltip>
        ) : null}
      </Row>
    );
  }
);

DocumentsBreadcrumbs.displayName = "DocumentsBreadcrumbs";
